export default function Section4() {
  return (
    <section className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
      <div className="container mx-auto px-4">
        <h2 className="text-[50px] font-normal text-white tracking-tight mb-4 text-center">
          Trust That Compounds. Access That Scales
        </h2>
        <h3 className="text-[18px] text-white mb-[70ox] tracking-tight text-center">
          Every transaction strengthens the network — building a sustainable
          economic flywheel powered by reputation, behavior, and programmable
          access
        </h3>
      </div>
    </section>
  );
}
